import { useGlobalConfig }                    from "context/GlobalContext";
import { RootLayout }                         from "layouts/RootLayout";
import React, { useEffect, useState }         from "react";
import { Navigate, 
         Outlet, 
         useLocation
       }                                      from "react-router";

export interface RouteGuardProps {
  children : React.ReactNode
}

export const RouteGuard = () => {

  const { rc } = useGlobalConfig();
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const init = async () => {
      setLoading(true);
      const errorMsg = await rc.session.init()
      if (errorMsg) {
        setLoading(false);
        return
      }
      setLoading(false);
    }

    init()
  }, [])
  
  const userLoggedIn = rc.session.isUserLoggedIn();
  const location = useLocation()

  return loading ? <></> : userLoggedIn ? 
    <RootLayout>
      <Outlet />
    </RootLayout> 
    : 
    <Navigate to="/auth" replace state={{ path : location.pathname}} />
}